import { CategoriesPage } from './CategoriesPage'
import { BurgerBoxPage } from './burger-box/BurgerBoxPage'
import { CouponsPage } from './coupons/CouponsPage'
import { GiftsPage } from './GiftsPage'
import { LunchMenuPage } from './lunch-menu/LunchMenuPage'
import { ProductsPage } from './products/ProductsPage'
import { PizzaConfigPage } from './pizza-config/PizzaConfigPage'
import { RecipesPage } from './recipes/RecipesPage'

/**
 * `manager-menu` — the kitchen's catalogue.
 *
 * All eight pages ported: categories, gifts, recipes, burger-box,
 * pizza-config, coupons, products, lunch-menu.
 */
export const managerMenuModule = {
  name: 'manager-menu',
  routes: [
    {
      path: '/categories',
      page: 'categories',
      guard: { permission: 'categories' },
      component: CategoriesPage,
    },
    {
      path: '/gifts',
      page: 'gifts',
      guard: { permission: 'gifts' },
      component: GiftsPage,
    },
    {
      path: '/recipes',
      page: 'recipes',
      guard: { permission: 'recipes', franchiseModule: 'stock.recipes' },
      component: RecipesPage,
    },
    {
      // The route and the page file disagree in legacy; the route wins.
      path: '/kombo-box',
      page: 'burger-box',
      guard: { permission: 'burger_box' },
      component: BurgerBoxPage,
    },
    {
      path: '/pizza',
      page: 'pizza-config',
      guard: { permission: 'pizza' },
      component: PizzaConfigPage,
    },
    {
      path: '/coupons',
      page: 'coupons',
      guard: { permission: 'coupons' },
      component: CouponsPage,
    },
    {
      path: '/products',
      page: 'products',
      guard: { permission: 'products' },
      component: ProductsPage,
    },
    {
      path: '/lunch-menu',
      page: 'lunch-menu',
      component: LunchMenuPage,
    },
  ],
} as const

export {
  BurgerBoxPage,
  CategoriesPage,
  CouponsPage,
  GiftsPage,
  LunchMenuPage,
  PizzaConfigPage,
  ProductsPage,
  RecipesPage,
}
